<div class="sidebar">
    <div>
        <div class="sidebar-head">
            <a [routerLink]="getDashboardLink()">
                <figure>
                <img src="assets/images/logo/logo.svg" alt="Logo" />
                </figure>
            </a>
            <span class="svg svg-toggle-icon" (click)="toggleSideBar()"></span>
        </div>
        <div class="title">Favorites</div>
        <ul class="list-none side-nav">
            <li *ngIf="isCompanyAdmin">
                <a [routerLink]="['/dashboard']" routerLinkActive="active">
                    <i class="svg sidebar-icon-1"></i>
                    <span>Dashboard</span>
                </a>
            </li>
            <li *ngIf="isEmployee || isCompanyAdmin">
                <a [routerLink]="['/synced-post']" routerLinkActive="active">
                    <i class="svg sidebar-icon-2"></i>
                    <span>Synced Posts</span>
                </a>
            </li>
            <li *ngIf="isEmployee || isCompanyAdmin">
                <a [routerLink]="['/synced-history']" routerLinkActive="active">
                    <i class="svg sidebar-icon-2"></i>
                    <span>Synced History</span>
                </a>
            </li>
            <li *ngIf="isCompanyAdmin">
                <a [routerLink]="['/reports']" routerLinkActive="active">
                    <i class="svg sidebar-icon-3"></i>
                    <span>Reports</span>
                </a>
            </li>
            <li *ngIf="isSuperAdmin">
                <a [routerLink]="['/company-management']" routerLinkActive="active">
                    <i class="svg sidebar-icon-6"></i>
                    <span>Company Management</span>
                </a>
            </li>
            <li *ngIf="isSuperAdmin">
                <a [routerLink]="['/role-management']" routerLinkActive="active">
                    <i class="svg sidebar-icon-5"></i>
                    <span>Role Management</span>
                </a>
            </li>
            <li *ngIf="isSuperAdmin">
                <a [routerLink]="['/user-management']" routerLinkActive="active">
                    <i class="svg sidebar-icon-4"></i>
                    <span>User Management</span>
                </a>
            </li>
            <li *ngIf="isCompanyAdmin">
                <a [routerLink]="['/employee-management']" routerLinkActive="active">
                    <i class="svg sidebar-icon-4"></i>
                    <span>Employee Management</span>
                </a>
            </li>
        </ul>
        <ng-container *ngIf="isEmployee || isCompanyAdmin">
            <div class="title">Connection</div>
            <div class="linkedIn-conn">
                <i class="svg svg-ln-icon"></i>
                <div class="box">
                    <span class="txt">LinkedIn</span>
                    <span class="status" [ngClass]="{'active': userData.isConnected == 'true'}">{{userData.isConnected === 'true' ? 'Connected as ' + userData.isConnectedUserName:'Not Connected'}} </span>
                </div>
            </div>
            <div class="linkedIn-conn">
                <i class="pi pi-facebook text-white"></i>
                <div class="box">
                    <span class="txt">Facebook (Consumer)</span>
                    <span class="status" [ngClass]="{'active': userData.isFbConnected == 'true'}">{{userData.isFbConnected === 'true' ? 'Connected as ' + userData.isConnectedFacebookUserName : 'Not Connected'}} </span>
                </div>
            </div>
            <div class="linkedIn-conn">
                <i class="pi pi-facebook text-white"></i>
                <div class="box">
                    <span class="txt">Facebook (Business)</span>
                    <span class="status" [ngClass]="{'active': userData.isFbBusinessConnected == 'true'}">{{userData.isFbBusinessConnected === 'true' ? 'Connected as ' + userData.isConnectedFacebookBusinessUserName : 'Not Connected'}} </span>
                </div>
            </div>
            <div class="linkedIn-conn">
                <i class="pi pi-instagram text-white"></i>
                <div class="box">
                    <span class="txt">Instagram</span>
                    <span class="status" [ngClass]="{'active': userData.isInstaConnected == 'true'}">{{userData.isInstaConnected === 'true' ? 'Connected as ' + userData.isConnectedInstaUserName : 'Not Connected'}} </span>
                </div>
            </div>
            <div class="linkedIn-conn">
                <i class="pi pi-twitter text-white"></i>
                <div class="box">
                    <span class="txt">Twitter</span>
                    <span class="status" [ngClass]="{'active': userData.isTwitterConnected == 'true'}">{{userData.isTwitterConnected === 'true' ? 'Connected as ' + userData.isConnectedTwitterUserName : 'Not Connected'}} </span>
                </div>
            </div>
        </ng-container>
    </div>
    <div>
        <div class="profile-box" (click)="menu.toggle($event)">
            <span class="placeholder-char flex align-items-center justify-content-center">
                {{ userData.firstName ? userData.firstName.charAt(0) : "-" }}
            </span>
            <div class="profile">
                <span class="name">{{(userData.firstName + userData.lastName) ? (userData.firstName +' '+ userData.lastName):'-'}}</span>
                <span class="mail">{{userData.email ? userData.email:'-'}}</span>
            </div>
        </div>
        <p-menu #menu [model]="items" [popup]="true" />
    </div>
</div>